import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Sidebar } from "@/components/sidebar";
import { useStore } from "@/store";
import { trackEvent } from "@/utils/trackEvent";

export const MobileShareButton = observer(function MobileShareButton() {
  const { dialog, doc } = useStore();
  const t = useTranslations();

  const handleShareButtonClick = () => {
    if (doc?.id) {
      trackEvent("share_button_clicked", { doc_id: doc.id });
    }
    dialog.shareDialog.open();
  };

  return <Sidebar.Button onClick={handleShareButtonClick}>{t("sidebar.share")}</Sidebar.Button>;
});
